export default class KategoriaService{

  constructor(server){
    this.server = server;
  }

  list(){
    return this.server("listKategorie");
  }

  save(item){
    return this.server("saveKategoria", {nazov: item});
  }

  update(item){
    return this.server("saveKategoria", item); 
  }

  remove(item){
    return this.server("removeKategoria", {id: item.id});
  }


}


// WEBPACK FOOTER //
// ./src/services/KategoriaService.js